import { useEffect } from 'react';

export const useUTMCapture = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    utmKeys.forEach((key) => {
      const value = params.get(key);
      if (value) {
        sessionStorage.setItem(key, value);
      }
    });
  }, []);
};

export const getStoredUTMs = () => ({
  utm_source: sessionStorage.getItem('utm_source'),
  utm_medium: sessionStorage.getItem('utm_medium'),
  utm_campaign: sessionStorage.getItem('utm_campaign'),
  utm_content: sessionStorage.getItem('utm_content'),
  utm_term: sessionStorage.getItem('utm_term'),
});
